import { v4 as uuid } from 'uuid';
import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { ILodgementApplicationBackChannelHistory } from './LodgementBackChannelHistory.interface';

export default class LodgementBackChannelHistory
  implements ILodgementApplicationBackChannelHistory {
  id: string;
  idWorkflow: string;
  idStage: string;
  idOwner: string;
  applicationId: string;
  lenderAssignedId: string;
  status: string;
  timeStamp: number;

  static build = (data: ILodgementApplicationBackChannelHistory) =>
    new LodgementBackChannelHistory(data);
  static blank = () => new LodgementBackChannelHistory();

  /**
   * Constructor
   * @param {ILodgementApplicationBackChannelHistory} data
   */
  constructor(data?: ILodgementApplicationBackChannelHistory) {
    this.id = toUUID(data?.id) || uuid();
    this.idWorkflow = toUUID(data?.idWorkflow);
    this.idOwner = toUUID(data?.idOwner);
    this.idStage = toUUID(data?.idStage);
    this.lenderAssignedId = data?.lenderAssignedId || undefined;
    this.applicationId = data?.applicationId || undefined;
    this.status = data?.status || undefined;
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
